module.exports = __webpack_public_path__ + "static/media/start.3bcb938e.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/tampa/ui/start.png
// module id = 788
// module chunks = 0